<script setup lang="ts">
import JournalCardSkeletonSection from '@/pages/journal/ui/Skeleton/JournalCardSkeletonSection.vue';

withDefaults(defineProps<{ isDetailPage?: boolean }>(), {
  isDetailPage: false,
});
</script>

<template>
  <ul :class="['journal-page-skeleton', { _detail: isDetailPage }]">
    <li v-for="i in 2" :key="i" class="journal-page-skeleton__item">
      <JournalCardSkeletonSection :is-detail-page="isDetailPage" />
    </li>
  </ul>
</template>

<style lang="less" scoped>
.journal-page-skeleton {
  .flex-column(@size-x10);

  &__item {
    padding-bottom: @size-x10;

    &:not(:last-child) {
      border-bottom: 1px solid @color-gallery;
    }
  }

  &._detail &__item {
    padding-bottom: 0;
    border-bottom: 0;
  }
}
</style>
